import { Injectable } from '@angular/core';
import {Jsonp, Http, Headers, URLSearchParams, RequestOptions, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import {Subscription} from 'rxjs/Subscription';
//import { QueryTask, Query, Point } from 'esri';

import QueryTask = require('esri/tasks/QueryTask');
import Query = require('esri/tasks/support/Query');
import Point = require('esri/geometry/Point');
import Graphic = require('esri/Graphic');
import SimpleFillSymbol = require('esri/symbols/SimpleFillSymbol');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import Color = require('esri/Color');
import GeometryService = require('esri/tasks/GeometryService');
import BufferParameters = require('esri/tasks/support/BufferParameters');
import ProjectParameters = require("esri/tasks/support/ProjectParameters");
import Geometry = require('esri/geometry/Geometry');
import Polygon = require('esri/geometry/Polygon');
import Polyline = require('esri/geometry/Polyline');
import Extent = require('esri/geometry/Extent');
import IdentifyParameters = require('esri/tasks/support/IdentifyParameters');
import IdentifyTask = require('esri/tasks/IdentifyTask');
import EsriRequest = require('esri/request');

@Injectable()
export class EsriTasksService {
    constructor(private _eventsService:EventsService, private http:Http, private jsonp:Jsonp){
    }

    getAPIPResultsByLocation(url:string, location:Object, wkid:string, layersArray:Array<any>){
        let layers = JSON.stringify(layersArray);
        let point = JSON.stringify({"x":location["X"],"y":location["Y"],"spatialReference":{"wkid":wkid}});
        var search = new URLSearchParams();
        search.set('f', 'json');
        search.set('point', point);
        search.set('layers', layers);
        var request:Object = {
            'f': 'json',
            'point': point,
            'layers': layers
        };
        return EsriRequest(url, new Object({query:request})).then(response => {
            return response;
        }, error => {
            return Promise.reject(error.message || error);
        });
    }

    soePolygonAnalysis(url:string, parcelGeometry:Geometry, layersArray:Array<any>, wkid:string, spatialRelationship:string){
        let layers = JSON.stringify(layersArray);
        var polygonObject:Object = {
            "type":"polygon", 
            "rings":(parcelGeometry as Polygon).rings, 
            "spatialReference":{"wkid":wkid}
        }
        let polygon:string = JSON.stringify(polygonObject);
        var request:Object = {
            'f': 'json',
            'polygon': polygon,
            'layers': layers,
            'returnGeometry': 'false',
            'spatialRelationship': spatialRelationship
        };
        return EsriRequest(url, new Object({query:request})).then(response => {
            return response;
        }, error => {
            return Promise.reject(error.message || error);
        });
    }

    createReport(url:string, textElementsObjectString:string, image1:string, image2:string, image3:string, image4:string){
        var request:Object = {
            "f":"json",
            "TextElementsStrings":textElementsObjectString,
            "Image1":image1,
            "Image2":image2,
            "Image3":image3,
            "Image4":image4
        }
        return EsriRequest(url, new Object({query:request})).then(response => {
            return response;
        }, error => {
            return Promise.reject(error.message || error);
        });
    }


    ///TEST
    makeEsriRequest_TEST(){
        return EsriRequest("http://gistv07:6080/arcgis/rest/services/DMDPortal/MapServer/identify", {"query": {
                geometry:'{"x":246212.11805555556,"y":1616275.548611111}"',
                geometryType:"esriGeometryPoint",
                sr:'{"wkt":"PROJCS[\"NAD_1983_StatePlane_Indiana_East_FIPS_1301_USFeet\",GEOGCS[\"GCS_North_American_1983\",DATUM[\"D_North_American_1983\",SPHEROID[\"GRS_1980\",6378137.0,298.257222101]],PRIMEM[\"Greenwich\",0.0],UNIT[\"Degree\",0.0174532925199433]],PROJECTION[\"Transverse_Mercator\"],PARAMETER[\"False_Easting\",328083.3333333333],PARAMETER[\"False_Northing\",820208.3333333331],PARAMETER[\"Central_Meridian\",-85.66666666666667],PARAMETER[\"Scale_Factor\",0.9999666666666667],PARAMETER[\"Latitude_Of_Origin\",37.5],UNIT[\"Foot_US\",0.3048006096012192]]"}',
                layers:"visible:0",
                layerDefs:'{"0":"LANDUSE = \'PARK\'"}',
                time:null,
                layerTimeOptions:null,
                tolerance:0,
                mapExtent:"84102.74305555553,1560285.9652777778,295257.2569444445,1733246.0347222222",
                imageDisplay:"400,400,96",
                returnGeometry:true,
                maxAllowableOffset:null,
                geometryPrecision:null,
                dynamicLayers:null,
                returnZ:false,
                returnM:false,
                gdbVersion:null,
                f:"pjson"
            }}
        )
    }

    identifyFeatures(url:string, geometry:Geometry, extent:Extent, tolerance:number, layerIds:Array<number>, layerOption:string, returnGeometry:boolean, definitionExpressions:Object){
        var identifyParams = new IdentifyParameters();
        identifyParams.tolerance = tolerance;
        identifyParams.returnGeometry = returnGeometry;
        identifyParams.layerIds = layerIds;
        identifyParams.layerOption = layerOption;
        identifyParams.geometry = geometry;
        identifyParams.mapExtent = extent;
        identifyParams.set("layerDefinitions", definitionExpressions);


        var identifyTask:IdentifyTask = new IdentifyTask({"url":url});
        return identifyTask.execute(identifyParams).then(results => {
            return results;
        }, error => {
            console.log(error);
            return Promise.reject(error.message || error);
        });

    }

    queryFeatures(url:string, geometry:Geometry, whereClause:string, outFields:string[], returnGeometry:boolean, orderFields:Array<string>){
        var queryTask = new QueryTask({"url":url});
        var query = new Query();
        query.geometry = geometry;
        query.returnGeometry = returnGeometry;
        query.outFields = outFields;
        query.orderByFields = orderFields;
        query.where = whereClause;
        return queryTask.execute(query).then(results => results);
    }

    queryFeaturesForIDs(url:string, geometry:Geometry, whereClause:string){
        var queryTask:QueryTask = new QueryTask({"url":url});
        var query = new Query();
        query.geometry = geometry;
        query.where = whereClause;
        return queryTask.executeForIds(query).then(results => {return {"url": url, "results":results}});
    }

    getFeaturesCounts(url:string){
        var queryTask = new QueryTask({"url":url});
        var query = new Query();
        query.where = "1=1";
        return queryTask.executeForCount(query).then(results => {
            return results;
        }, error => {
            console.log(error);
            return Promise.reject(error.message || error);
        });
    }

    bufferFeatures(url, geometries, distances, unit, sr){
        var gsvc = new GeometryService(url);
        var params = new BufferParameters();
        var bufferGeometries = new Array();
        for (var i = 0; i < geometries.length; i++) {
            bufferGeometries.push(geometries[i]);
        }
        params.geometries = bufferGeometries;
        params.unit = "feet";
        params.outSpatialReference = sr;
        params.distances = distances;
        return gsvc.buffer(params).then(geometries => geometries);
    }

    unionGeometries(url, geometries){
        var gsvc = new GeometryService(url);
        return gsvc.union(geometries).then(unionGeometry => unionGeometry);
    }

    projectGeometries(url, geometries, sr){
        var gsvc = new GeometryService(url);
        var params = new ProjectParameters();
        params.outSR = sr;
        params.geometries = geometries;
        return gsvc.project(params).then(geometries => geometries);
    }

    geometryToGML(geom:Geometry){
        var gml = '';
        switch (geom.type) {
            // case "point":
            //     gml = pointToGML(geom);
            //     if (buffer == true) {
            //         gml = '<RequestGeometries><Geometries><BufferGeometry><Geometry>' + gml + '</Geometry></BufferGeometry></Geometries></RequestGeometries>';
            //     }
            //     break;
            // case "multipoint": //not sure about this GML
            //     gml = multipointToGML(geom);
            //     break;
            // case "polyline":
            //     gml = lineToGML(geom);
            //     break;
            case "polygon":
                var gml = this.polygonToGML(geom as Polygon);
                // if (buffer == true) {
                //     gml = '<RequestGeometries><Geometries><BufferGeometry><Geometry>' + gml + '</Geometry></BufferGeometry></Geometries></RequestGeometries>';
                // }
                break;
            // case "extent":
            //     gml = extentToGML(geom);
            //     break;
        }
        return gml;
    }

    private polygonToGML(geom:Polygon){
        var rings = geom.rings;
        var gml = '<gml:Polygon xmlns:gml="http://www.opengis.net/gml"><gml:PolygonPatch><gml:exterior>';
        for (var ii = 0; ii < rings.length; ii++) {
            var points = rings[ii];
            gml = gml + '<gml:LinearRing><gml:posList>';
            var pointStart = points[0];
            var coordStart = pointStart[0] + ',' + pointStart[1];
            for (var jj = 0; jj < points.length; jj++) {
                var point = points[jj];
                gml = gml + point[0] + ',' + point[1] + ' ';
            }
            gml = gml + coordStart + '</gml:posList></gml:LinearRing>';
        }
        gml = gml + '</gml:exterior></gml:PolygonPatch></gml:Polygon>';
        return gml;
    }

    private gmlToPoint(sr,gml) {
        gml = gml.replace(', ', ',');
        var positionPos = gml.indexOf('<gml:pos>', 0);
        var positionStartPos = gml.indexOf('>', positionPos);
        var positionEndPos = gml.indexOf('<', positionStartPos);
        var pointString = gml.slice((positionStartPos + 1), positionEndPos);
        var pointArray = pointString.split(',');
        var geom:Point = new Point();
        geom.spatialReference = sr;
        geom.x = Number(pointArray[0]);
        geom.y = Number(pointArray[1])
        return geom;
    }


    private gmlToPolygon(sr, gml:string) {
        var geom:Polygon = new Polygon();
        geom.spatialReference = sr;
        gml = gml.replace(', ', ',');
        var positionRing = 0; 
        var positionPosList = 0;
        var geomRingsArray = [];
        while (positionRing != -1)
        {
            //Get this rings XY coordinates
            positionRing = gml.indexOf('<gml:LinearRing>', (positionRing + 1));
            positionPosList = gml.indexOf('<gml:posList>', (positionPosList + 1));
            var startRingValues = gml.indexOf('>', positionPosList);
            var endRingValues = gml.indexOf('<', startRingValues);
            var ringString = gml.slice((startRingValues + 1), (endRingValues));
            var ringArray = ringString.split(' ');
            //Create the ring
            var ring = new Array();
            for (var ii = 0; ii < ringArray.length; ii++) {
                //Get the xy coordinates
                var ringPoint = ringArray[ii];
                var ringPointArray = ringPoint.split(',');
                var x = ringPointArray[0];
                var y = ringPointArray[1];
                
                //Create the point and add it to the ring's array of points
                var pt = new Point();
                pt.x = Number(x);
                pt.y = Number(y);
                pt.spatialReference = sr;
                ring.push(pt);
            }
            //add this ring to the polygon's rings
            geom.addRing(ring);
            //Get next ring if current position is not -1
            if (positionRing != -1) {
                positionRing = gml.indexOf('<gml:LinearRing>', (positionRing + 1));
            }
        }
        return geom;
    }

    private gmlToLine(sr, gml){
        gml = gml.replace(', ', ',');
        var positionPos = gml.indexOf('<gml:posList>', 0);
        var positionStartPos = gml.indexOf('>', positionPos);
        var positionEndPos = gml.indexOf('<', positionStartPos);
        var pointString = gml.slice((positionStartPos + 1), positionEndPos);

        var pointsArray = [];
        var pointsStringArray = pointString.split(' ');
        for (var ii = 0; ii<pointsStringArray.length; ii++) {
            var pointCoord = pointsStringArray[ii].split(',');
            pointsArray.push(pointCoord);
        }
        var paths = [];
        for (var jj = 0; jj < pointsArray.length; jj++) {
            var point = new Point();
            point.spatialReference = sr;
            point.x = Number(pointsArray[0]);
            point.x = Number(pointsArray[1]);
            paths.push(point);
        }
        var geom = new Polyline();
        geom.spatialReference = sr;
        geom.addPath(paths);
        
        return geom;
    }

    gmlToGeometry(spatialReference, gml) {
        //Determine the type of geometry to be created
        var typePolygon = gml.indexOf('gml:Polygon',0);
        var typePoint = gml.indexOf('gml:Point',0);
        var typeLine = gml.indexOf('gml:LineString',0)
        var geom;
        if (typePolygon != -1){
            //Case when the geometry type supposed to be generated is Polygon
            geom = this.gmlToPolygon(spatialReference, gml);
        }
        else if (typePoint != -1){
            //Case when the geometry type supposed to be generated is Point
            geom = this.gmlToPoint(spatialReference, gml);
        }
        else if (typeLine != -1){
            //Case when the geometry type supposed to be generated is Polyline
            geom = this.gmlToLine(spatialReference, gml);
        }
        return geom;
    }

    getServiceValues(url:string){
        return this.http.get(url)
             .toPromise()
             .then(this.extractData)
             .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || { };
    }

    
    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./app/esriTasks/esriTasks-service.ts